/**
 * Application wide constants.
 */

export const DEFAULT_LANGUAGE_KEY = 'de';
export const DAY_IN_MS = 1000 * 60 * 60 * 24;
export const HOURS_IN_MS = 1000 * 60 * 60;
export const MINUTES_IN_MS = 1000 * 60;

export const drawerWidth = 450;
export const drawerWidth_xl = 500;

export const LOCAL_STORAGE_DEVICE_UUID = 'deviceUUID';
export const LOCAL_STORAGE_WEBPUSH_SUBSCRIPTION = 'webpushSubscription';
export const LOCAL_STORAGE_DOCUMENT_SORTER_NAME = 'documentSorterName';
export const LOCAL_STORAGE_DOCUMENT_SORTER_NAMES_BY_INSTANCE = 'documentSorterNamesByInstance';

// export const PDF_VIEWERS = ['pdfjs', 'pdfjsexpress'];
export const PDF_VIEWERS = ['pdfjs', 'pdfjsexpress', 'desktopembedded'];
export const PDFJS = 'pdfjs';
export const PDFJS_EXPRESS = 'pdfjsexpress';
export const DISPLAY_PDF_VIEWER_HINT_MODE = {
  display: 'display',
  button: 'button',
  none: 'none',
};

export const OPEN_RATINGS_COUNT = 'openRatingsCount';
export const CLOSED_RATINGS_COUNT = 'closedRatingsCount';
export const OPEN_EVALUATIONS_COUNT = 'openEvaluationsCount';
export const CLOSED_EVALUATIONS_COUNT = 'closedEvaluationsCount';
export const SORT_BY_NEWEST = 'id-desc';
export const SORT_BY_OLDEST_FIRST = 'id-asc';
export const SORT_BY_ALPHABETIC_ASC = 'a-z';
export const SORT_BY_ALPHABETIC_DESC = 'z-a';
export const SORT_BY_DISPLAY_START_DESC = 'display_start_desc';
export const SORT_BY_DISPLAY_START_ASC = 'display_start_asc';
export const SORT_BY_CREATED_DESC = 'created-desc';
export const SORT_BY_CREATED_ASC = 'created-asc';
export const SORT_BY_UPDATED_DESC = 'updated-desc';
export const SORT_BY_UPDATED_ASC = 'updated-asc';
export const MEDIA_SORT_KEY = 'media_sort_by';
